import { getQuestionId } from "./listeningPreload";

export const PRELOADABLE_QUESTION_CATEGORIES = ["Speaking", "Writing", "Reading"];
export const MOCK_QUESTION_PRELOAD_WINDOW = 3;

export const getCategoryQuestionsFromStep = (
  questions = [],
  currentStep = 1,
  category
) =>
  questions
    .slice(Math.max(0, currentStep - 1))
    .filter((question) => question?.Category === category);

export const getPreloadCategory = (category) =>
  PRELOADABLE_QUESTION_CATEGORIES.includes(category) ? category : null;

export const shouldMarkPreloadFailed = (response) => !response?.data;

export const getPreloadWindowQuestions = (
  questions = [],
  currentStep = 1,
  category,
  preloadWindow = MOCK_QUESTION_PRELOAD_WINDOW
) =>
  getCategoryQuestionsFromStep(questions, currentStep, category).slice(
    0,
    preloadWindow
  );

export const isCategoryReady = (
  questions = [],
  currentStep = 1,
  category,
  questionCache = {}
) => {
  const categoryQuestions = getCategoryQuestionsFromStep(
    questions,
    currentStep,
    category
  );

  return (
    categoryQuestions.length > 0 &&
    categoryQuestions.every((question) => Boolean(questionCache[getQuestionId(question)]))
  );
};

export const isCurrentQuestionReady = (
  questions = [],
  currentStep = 1,
  questionCache = {},
  preloadFailures = {}
) => {
  const currentQuestion = questions[currentStep - 1];
  if (!getPreloadCategory(currentQuestion?.Category)) return true;

  const questionId = getQuestionId(currentQuestion);
  return Boolean(questionCache[questionId] || preloadFailures[questionId]);
};

export const getNextCategory = (questions = [], currentCategory) => {
  const categories = [...new Set(questions.map((question) => question?.Category).filter(Boolean))];
  const currentIndex = categories.indexOf(currentCategory);
  return currentIndex >= 0 ? categories[currentIndex + 1] || null : null;
};
